<mat-selection-list
  *ngIf="!!documentOptionSets"
  aria-label="Document Options"
  [color]="color"
  [ngModel]="selected"
  [compareWith]="_compareWithDocumentOptionSets"
  (selectionChange)="handleSelectionChange($event)"
>
  <mat-list-option
    *ngFor="let dos of documentOptionSets"
    [value]="dos"
    [attr.aria-labelledby]="'rds-document-label-' + dos.document.uri"
    [attr.aria-describedby]="'rds-document-description-' + dos.document.uri"
  >
    <h3 matLine [attr.id]="'rds-document-label-' + dos.document.uri">{{ dos.document.name }}</h3>
    <p *ngIf="dos.document.description as desc" matLine [attr.id]="'rds-document-description-' + dos.document.uri">{{ desc }}</p>
    <ul [attr.aria-labelledby]="'rds-document-file-' + dos.document.uri" fxLayout="row wrap">
      <li class="dense rds-c-chip">
        {{ dos.document.fileName }}
      </li>
    </ul>
  </mat-list-option>
</mat-selection-list>
